// 3c) Project-specific modules - components / types
// Using entity-types for base types to avoid circular dependencies
import type {
    PageData,
    CustomField,
    Attachment,
    ConversationLineBase,
    AgedTrialBalance,
    AgedTrialBalanceFrom,
    AgedTrialBalanceNotDue,
    Contact,
    LastCommunication,
    DeliveryDetails,
    CompanyBase,
    InvoiceBase,
    CreditBase,
    PaymentBase,
    TaskBase,
} from '../entity-types';
import type { ConversationState } from '../common/types';

// 3d) Utility functions / interfaces
import {
    AddCommentCommonFilterPayload,
    ResponseModalObject,
    AssignUserCommonFilterPayload,
} from '../../utils/commonInterfaces';

export enum CustomersActionTypes {
    GET_CUSTOMERS_REQUEST = '@@customers/GET_CUSTOMERS_REQUEST',
    GET_CUSTOMERS_FOR_ORGANISATION_REQUEST = '@@customers/GET_CUSTOMERS_FOR_ORGANISATION_REQUEST',
    GET_CUSTOMERS_FOR_PAYMENTPLANS_REQUEST = '@@customers/GET_CUSTOMERS_FOR_PAYMENTPLANS_REQUEST',
    GET_CUSTOMERS_SUCCESS = '@@customers/GET_CUSTOMERS_SUCCESS',
    GET_CUSTOMERS_ERROR = '@@customers/GET_CUSTOMERS_ERROR',
    UPDATE_CUSTOMERS_FILTERS = '@@customers/UPDATE_CUSTOMERS_FILTERS',
    UPDATE_CUSTOMERS_SORT_BY_AND_ATB = '@@customers/UPDATE_CUSTOMERS_SORT_BY_AND_ATB',
    UPDATE_CUSTOMERS_TABLE_FILTER_STATE = '@@customers/UPDATE_CUSTOMERS_TABLE_FILTER_STATE',
    CLEAR_CUSTOMERS_STATE_ALL_TABLE_FILTERS = '@@customers/CLEAR_CUSTOMERS_STATE_ALL_TABLE_FILTERS',
    CLEAR_CUSTOMERS_STATE_DATA = '@@customers/CLEAR_CUSTOMERS_STATE_DATA',
    GET_CUSTOMER_CUSTOM_FIELDS_FOR_COMPANY_REQUEST = '@@customers/GET_CUSTOMER_CUSTOM_FIELDS_FOR_COMPANY_REQUEST',
    GET_CUSTOMER_CUSTOM_FIELDS_FOR_ORGANISATION_REQUEST = '@@customers/GET_CUSTOMER_CUSTOM_FIELDS_FOR_ORGANISATION_REQUEST',

    SET_CUSTOMER_SELECTED_ID_REQUEST = '@@customers/SET_CUSTOMER_SELECTED_ID_REQUEST',
    SET_CUSTOMER_SELECTED_ID_SUCCESS = '@@customers/SET_CUSTOMER_SELECTED_ID_SUCCESS',
    GET_CUSTOMER_DATA_REQUEST = '@@customers/GET_CUSTOMER_DATA_REQUEST',
    GET_ORGANISATION_CUSTOMER_DATA_REQUEST = '@@customers/GET_ORGANISATION_CUSTOMER_DATA_REQUEST',
    GET_CUSTOMER_DATA_SUCCESS = '@@customers/GET_CUSTOMER_DATA_SUCCESS',
    GET_CUSTOMER_DATA_ERROR = '@@customers/GET_CUSTOMER_DATA_ERROR',
    CLEAR_CUSTOMER_DATA_SUCCESS = '@@customers/CLEAR_CUSTOMER_DATA_SUCCESS',

    GET_CHILD_CUSTOMERS_REQUEST = '@@customers/GET_CHILD_CUSTOMERS_REQUEST',
    GET_CHILD_CUSTOMERS_FOR_ORGANISATION_REQUEST = '@@customers/GET_CHILD_CUSTOMERS_FOR_ORGANISATION_REQUEST',
    GET_CHILD_CUSTOMERS_SUCCESS = '@@customers/GET_CHILD_CUSTOMERS_SUCCESS',
    GET_CHILD_CUSTOMERS_ERROR = '@@customers/GET_CHILD_CUSTOMERS_ERROR',
    UPDATE_CHILD_CUSTOMERS_FILTERS = '@@customers/UPDATE_CHILD_CUSTOMERS_FILTERS',
    UPDATE_CHILD_CUSTOMERS_SORT_BY_AND_ATB = '@@customers/UPDATE_CHILD_CUSTOMERS_SORT_BY_AND_ATB',
    UPDATE_CHILD_CUSTOMERS_TABLE_FILTER_STATE = '@@customers/UPDATE_CHILD_CUSTOMERS_TABLE_FILTER_STATE',

    SET_PARENT_CUSTOMER_SELECTED_ID_REQUEST = '@@customers/SET_PARENT_CUSTOMER_SELECTED_ID_REQUEST',
    SET_PARENT_CUSTOMER_SELECTED_ID_SUCCESS = '@@customers/SET_PARENT_CUSTOMER_SELECTED_ID_SUCCESS',
    GET_PARENT_CUSTOMER_DATA_REQUEST = '@@customers/GET_PARENT_CUSTOMER_DATA_REQUEST',
    GET_ORGANISATION_PARENT_CUSTOMER_DATA_REQUEST = '@@customers/GET_ORGANISATION_PARENT_CUSTOMER_DATA_REQUEST',
    GET_PARENT_CUSTOMER_DATA_SUCCESS = '@@customers/GET_PARENT_CUSTOMER_DATA_SUCCESS',
    GET_PARENT_CUSTOMER_DATA_ERROR = '@@customers/GET_PARENT_CUSTOMER_DATA_ERROR',
    CLEAR_PARENT_CUSTOMER_DATA_SUCCESS = '@@customers/CLEAR_PARENT_USTOMER_DATA_SUCCESS',
  
    GET_CUSTOMER_INVOICES_REQUEST = '@@customers/GET_CUSTOMER_INVOICES_REQUEST',
    GET_ORGANISATION_CUSTOMER_INVOICES_REQUEST = '@@customers/GET_ORGANISATION_CUSTOMER_INVOICES_REQUEST',
    GET_CUSTOMER_INVOICES_SUCCESS = '@@customers/GET_CUSTOMER_INVOICES_SUCCESS',
    GET_CUSTOMER_INVOICES_ERROR = '@@customers/GET_CUSTOMER_INVOICES_ERROR',
    UPDATE_CUSTOMER_INVOICES_FILTERS = '@@customers/UPDATE_CUSTOMER_INVOICES_FILTERS',
    UPDATE_CUSTOMER_INVOICES_SORT_BY_AND_STATE = '@@customers/UPDATE_CUSTOMER_INVOICES_SORT_BY_AND_STATE',
    UPDATE_CUSTOMER_INVOICES_TABLE_FILTER_STATE = '@@customers/UPDATE_CUSTOMER_INVOICES_TABLE_FILTER_STATE',

    SAVE_CUSTOMER_UPDATE_REQUEST = '@@customers/SAVE_CUSTOMER_UPDATE_REQUEST',
    SAVE_ORGANISATION_CUSTOMER_UPDATE_REQUEST = '@@customers/SAVE_ORGANISATION_CUSTOMER_UPDATE_REQUEST',
    SAVE_CUSTOMER_UPDATE_RESPONSE = '@@customers/SAVE_CUSTOMER_UPDATE_RESPONSE',
    BULK_SAVE_CUSTOMER_UPDATE_REQUEST = '@@customers/BULK_SAVE_CUSTOMER_UPDATE_REQUEST',
    BULK_SAVE_CUSTOMER_UPDATE_RESPONSE = '@@customers/BULK_SAVE_CUSTOMER_UPDATE_RESPONSE',

    GET_CUSTOMER_CONVERSATION_REQUEST = '@@customers/GET_CUSTOMER_CONVERSATION_REQUEST',
    GET_ORGANISATION_CUSTOMER_CONVERSATION_REQUEST = '@@customers/GET_ORGANISATION_CUSTOMER_CONVERSATION_REQUEST',
    GET_CUSTOMER_CONVERSATION_SUCCESS = '@@customers/GET_CUSTOMER_CONVERSATION_SUCCESS',
    GET_CUSTOMER_CONVERSATION_ERROR = '@@customers/GET_CUSTOMER_CONVERSATION_ERROR',
    UPDATE_CUSTOMER_CONVERSATION_FILTERS = '@@customers/UPDATE_CUSTOMER_CONVERSATION_FILTERS',
    UPDATE_CUSTOMER_CONVERSATION_TABLE_FILTER = '@@customers/UPDATE_CUSTOMER_CONVERSATION_TABLE_FILTER',
    UPDATE_CUSTOMER_CONVERSATION_SORT_BY = '@@customers/UPDATE_CUSTOMER_CONVERSATION_SORT_BY',

    CUSTOMER_ADD_COMMENT_REQUEST = '@@customers/CUSTOMER_ADD_COMMENT_REQUEST',
    ORGANISATION_CUSTOMER_ADD_COMMENT_REQUEST = '@@customers/ORGANISATION_CUSTOMER_ADD_COMMENT_REQUEST',
    
    CUSTOMER_SEND_INFORMATION_REQUEST = '@@customers/CUSTOMER_SEND_INFORMATION_REQUEST',

    GET_CUSTOMER_CREDITS_REQUEST = '@@customers/GET_CUSTOMER_CREDITS_REQUEST',
    GET_ORGANISATION_CUSTOMER_CREDITS_REQUEST = '@@customers/GET_ORGANISATION_CUSTOMER_CREDITS_REQUEST',
    GET_CUSTOMER_CREDITS_SUCCESS = '@@customers/GET_CUSTOMER_CREDITS_SUCCESS',
    GET_CUSTOMER_CREDITS_ERROR = '@@customers/GET_CUSTOMER_CREDITS_ERROR',
    UPDATE_CUSTOMER_CREDITS_FILTERS = '@@customers/UPDATE_CUSTOMER_CREDITS_FILTERS',
    UPDATE_CUSTOMER_CREDITS_SORT_BY_AND_STATE = '@@customers/UPDATE_CUSTOMER_CREDITS_SORT_BY_AND_STATE',
    UPDATE_CUSTOMER_CREDITS_TABLE_FILTER_STATE = '@@customers/UPDATE_CUSTOMER_CREDITS_TABLE_FILTER_STATE',

    GET_CUSTOMER_PAYMENTS_REQUEST = '@@customers/GET_CUSTOMER_PAYMENTS_REQUEST',
    GET_ORGANISATION_CUSTOMER_PAYMENTS_REQUEST = '@@customers/GET_ORGANISATION_CUSTOMER_PAYMENTS_REQUEST',
    GET_CUSTOMER_PAYMENTS_SUCCESS = '@@customers/GET_CUSTOMER_PAYMENTS_SUCCESS',
    GET_CUSTOMER_PAYMENTS_ERROR = '@@customers/GET_CUSTOMER_PAYMENTS_ERROR',
    UPDATE_CUSTOMER_PAYMENTS_FILTERS = '@@customers/UPDATE_CUSTOMER_PAYMENTS_FILTERS',
    UPDATE_CUSTOMER_PAYMENTS_SORT_BY = '@@customers/UPDATE_CUSTOMER_PAYMENTS_SORT_BY',
    UPDATE_CUSTOMER_PAYMENTS_TABLE_FILTER = '@@customers/UPDATE_CUSTOMER_PAYMENTS_TABLE_FILTER',

    GET_MANUAL_COMMUNICATION_TEMPLATE_OPTIONS = '@@customers/GET_MANUAL_COMMUNICATION_TEMPLATE_OPTIONS',
    CUSTOMER_ASSIGN_USER_REQUEST = '@@customers/CUSTOMER_ASSIGN_USER_REQUEST',
    GET_CUSTOMER_FIRST_LETTER_VALUES_REQUEST = '@@customers/GET_CUSTOMER_FIRST_LETTER_VALUES_REQUEST',
    GET_CUSTOMER_FIRST_LETTER_VALUES_FOR_ORGANISATION_REQUEST = '@@customers/GET_CUSTOMER_FIRST_LETTER_VALUES_FOR_ORGANISATION_REQUEST',
    CUSTOMERS_FETCHED_FOR_ORGANISATION_RECEIVED = '@@customers/CUSTOMERS_FETCHED_FOR_ORGANISATION_RECEIVED',
    CUSTOMER_INVOICES_FETCHED_FOR_ORGANISATION_RECEIVED = '@@customers/CUSTOMER_INVOICES_FETCHED_FOR_ORGANISATION_RECEIVED',
    CUSTOMER_CREDITS_FETCHED_FOR_ORGANISATION_RECEIVED = '@@customers/CUSTOMER_CREDITS_FETCHED_FOR_ORGANISATION_RECEIVED',
    CUSTOMER_PAYMENTS_FETCHED_FOR_ORGANISATION_RECEIVED = '@@customers/CUSTOMER_PAYMENTS_FETCHED_FOR_ORGANISATION_RECEIVED',
    CUSTOMER_CONVERSATION_LINES_FETCHED_FOR_ORGANISATION_RECEIVED = '@@customers/CONVERSATION_LINES_FETCHED_FOR_ORGANISATION_RECEIVED',
}

export interface CustomersState {
    readonly loading: boolean;
    readonly saveCustomerDataLoading: boolean;
    readonly errorMessages: string[];
    readonly data: Customer[];
    readonly pageData: PageData;
    readonly filters: GetCustomersRequestPayload['filters'];
    readonly sortBy: GetCustomersRequestPayload['sortBy'];
    readonly atbType: number;
    readonly sortAscending: boolean;
    readonly tableFilter: string | undefined;
    readonly stateOfCustomers: string;
    readonly activeData: {
        loading: boolean;
        record: {};
        children: {
            readonly loading: boolean;
            readonly errorMessages: string[];
            readonly data: Customer[];
            readonly pageData: PageData;
            readonly filters: GetCustomersRequestPayload['filters'];
            readonly sortBy: GetCustomersRequestPayload['sortBy'];
            readonly sortAscending: boolean;
        };
        invoices: {
            readonly loading: boolean;
            readonly errorMessages: string[];
            readonly data: InvoiceBase[];
            readonly pageData: PageData;
            readonly filters: any;
            readonly sortBy: any;
            readonly sortAscending: boolean;
            readonly invoiceState: string;
        };
        credits: {
            readonly loading: boolean;
            readonly errorMessages: string[];
            readonly data: CreditBase[];
            readonly pageData: PageData;
            readonly filters: any;
            readonly sortBy: any;
            readonly sortAscending: boolean;
            readonly creditState: string;
        };
        rebates: {
            readonly loading: boolean;
            readonly errorMessages: string[];
            readonly data: CreditBase[];
            readonly pageData: PageData;
            readonly filters: any;
            readonly sortBy: any;
            readonly sortAscending: boolean;
            readonly creditState: string;
        };
        payments: {
            readonly loading: boolean;
            readonly errorMessages: string[];
            readonly data: PaymentBase[];
            readonly pageData: PageData;
            readonly filters: any;
            readonly sortBy: any;
            readonly sortAscending: boolean;
            readonly paymentState: string;
        };
        
        conversation: ConversationState;
        selectedId: string | null;
        errorMessages: string[];
    };
    parentActiveData: {
        loading: boolean;
        record: {};
        children: {
            readonly loading: boolean;
            readonly errorMessages: string[];
            readonly data: Customer[];
            readonly pageData: PageData;
            readonly filters: GetCustomersRequestPayload['filters'];
            readonly sortBy: GetCustomersRequestPayload['sortBy'];
            readonly sortAscending: boolean;
        };
        invoices: {
            readonly loading: boolean;
            readonly errorMessages: string[];
            readonly data: InvoiceBase[];
            readonly pageData: PageData;
            readonly filters: any;
            readonly sortBy: any;
            readonly sortAscending: boolean;
            readonly invoiceState: string;
        };
        credits: {
            readonly loading: boolean;
            readonly errorMessages: string[];
            readonly data: CreditBase[];
            readonly pageData: PageData;
            readonly filters: any;
            readonly sortBy: any;
            readonly sortAscending: boolean;
            readonly creditState: string;
        };
        rebates: {
            readonly loading: boolean;
            readonly errorMessages: string[];
            readonly data: CreditBase[];
            readonly pageData: PageData;
            readonly filters: any;
            readonly sortBy: any;
            readonly sortAscending: boolean;
            readonly creditState: string;
        };
        payments: {
            readonly loading: boolean;
            readonly errorMessages: string[];
            readonly data: CreditBase[];
            readonly pageData: PageData;
            readonly filters: any;
            readonly sortBy: any;
            readonly sortAscending: boolean;
        };        
        conversation: ConversationState;
        selectedId: string | null;
        errorMessages: string[];
    };
}

export interface Customer {
    readonly Id: string;
    readonly CustomerCode: string;
    readonly CompanyName: string;
    readonly IsVip: boolean;
    readonly IsVipExpiryDate: string;
    readonly NewInvoiceSendMode: string;
    readonly AgedTrialBalance: AgedTrialBalance;
    readonly Contacts: Contact[];
    readonly DisplayName: string;
    readonly TicketCount: number;
    readonly ConversationLine: ConversationLineBase;
    readonly CustomFields: CustomField[];
    readonly Attachments: Attachment[];
    readonly LastCommunication: LastCommunication;
    readonly CurrentTask: TaskBase;
    readonly Company: CompanyBase;
    readonly PayerState: string;
    readonly CreditLimit: number;
    readonly TotalCreditUsed: number;
    readonly WorkflowName: string;
    readonly Invoices: InvoiceBase[];
    readonly ParentCustomer?: Customer | null;
}

// Re-export types from entity-types for backwards compatibility
export type { LastCommunication, DeliveryDetails, AgedTrialBalance, AgedTrialBalanceFrom, AgedTrialBalanceNotDue, Contact } from '../entity-types';

export interface GetCustomersRequestPayload {
    filters: {
        Customer: string;
        InclusiveContact?: boolean;
        Contact?: number;
        AmountType: string;
        AmountValue: string;
        AmountOperator: string;
        CompanyIds?: string[];
    };
    tableFilter?: string;
    atbType: number;
    sortBy: string;
    sortAscending: boolean;
    stateOfCustomers: string;
    pageSize: number;
    currentPage: number;
    isUsingCloudImportType?: boolean;
    usingMultipleWorkflow?: boolean;
    usingCustomerWorkflow?: boolean;
    region?: string;
    conversionCurrency?: number;
    organisationCurrencies?: CustomerOrganisationCurrency[];
}

export interface BulkSaveCustomerUpdateRequestPayload {
    filter: {};
    customerIds: string[] | number[];
    excludeCustomers: boolean;
    customerObject: {};
    stateOfCustomers: string;
    callback?: (response: ResponseModalObject) => void;
}

export interface SaveCustomerUpdateRequestPayload {
    customerId: string;
    customerObject: {};
    companyId?: string | undefined;
    callback?: (response: ResponseModalObject) => void;
}

export interface CustomerAddCommentRequestPayload
    extends AddCommentCommonFilterPayload {
    customerIds: string[] | number[];
    excludeCustomers: boolean;
}

export interface CustomerSendInformationRequestPayload {
    TemplateName: string;
    filter: {};
    customerIds: string[] | number[];
    excludeCustomers: boolean;
    callback?: Function;
    isCustomerPortalSendingStatement?: boolean;
    alternativesEmail?: string;
    invoiceIds?: string[];
    excludeInvoices?: boolean;
}

export interface CustomerOrganisationCurrency {
    Value: string;
    Rate: number;
}

export interface ManualCommunicationTemplate {
    TemplateName: string;
    SentToVip: boolean;
}

export interface CustomerAssignUserRequestPayload
    extends AssignUserCommonFilterPayload {
    customerIds: string[] | number[];
    excludeCustomers: boolean;
    userObject: {};
    companyId: string;
}
export interface CustomersFetchedData {
    OnCustomersFetchedForOrganisation: {
        Customers: Customer[];
    };
};

export interface CustomersFetchedForOrganisationPayload {
    data: CustomersFetchedData;
    pageSize: number;
    currentPage: number;
}

export interface ParentCustomer {
    Customer: Customer
}